module.exports = __webpack_public_path__ + "static/media/blutec-copia.ec491562.png";